import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EventQADialog.html?raw';
import domAttr from 'dojo/dom-attr';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// NOTE (JS2TS): original define() also listed dojo/dijit deps never referenced in code and not
// used via data-dojo-type (connect, lang, array, Color, keys, dijit _WidgetBase/_TemplatedMixin/
// _WidgetsInTemplateMixin, registry, on, dom-style, dom-class, dom-construct, mouse) — dead, dropped.

class EventQADialog extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    callback: any = function () { };
    bookingID: any = null;
    entityID: any = null;
    entity: any = null;
    jsonData: any = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.placeAt(document.body);
    }

    _loadData(entityID: any): void {
        // request ...
    }

    serializeData(): void {
        var data: any = {
            bookingID: this.bookingID,
            question: this.inputQuestion.value,
            answer: this.inputAnswer.value
        };

        if (this.entity != null) {
            data.ID = this.entity.ID;
        }

        this.jsonData = data;
    }

    _getDataAttr(): any {
        return this.jsonData;
    }

    _setEntityAttr(entity: any): void {
        this.entity = entity;
        this.onChanged_Entity();
    }

    onChanged_Entity(): void {
        var entity = this.entity;

        if (entity == null) {
            return;
        }

        this.bookingID = entity.ref_vt_event_planning.ID;

        domAttr.set(this.authorNameNode, "innerHTML", entity.ref_asker.dispname);
        domAttr.set(this.responderNameNode, "innerHTML", entity.ref_responder.dispname);

        domAttr.set(this.inputQuestion, "value", entity.question);
        domAttr.set(this.inputAnswer, "value", entity.answer);

        this.applyPrivileges();
    }

    applyPrivileges(): void {
        var entity = this.entity;

        var bQuestionWriteable = false;
        var bAnswerWriteable = false;

        if (entity == null) { // neuer Datensatz
            bQuestionWriteable = true;
            bAnswerWriteable = false;
        } else {
            bQuestionWriteable = entity._isAsker == true;
            bAnswerWriteable = entity._isResponder == true;
        }

        if (bQuestionWriteable == true) {
            domAttr.remove(this.inputQuestion, "disabled");
            this.inputQuestion.focus();
        } else {
            domAttr.set(this.inputQuestion, "disabled", "disabled");
        }

        if (bAnswerWriteable == true) {
            domAttr.remove(this.inputAnswer, "disabled");
            this.inputAnswer.focus();
        } else {
            domAttr.set(this.inputAnswer, "disabled", "disabled");
        }
    }

    startup(entity?: any): void {
        super.startup.apply(this, arguments as any);

        if (typeof (entity) == "undefined" || entity == null) {
            this.applyPrivileges();
        }

        else if (typeof (entity) == "object") {
            // entity schon da
            this.set("Entity", entity);
        }

        else if (typeof (entity) == "string") { // ID
            this._loadData(entity);
        }

    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }

}
EventQADialog.prototype.declaredClass = 'ZAL.EventQADialog.EventQADialog';

export default mdsWidget(EventQADialog);
